import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  validateBeforeSubmit(event) {
    const form = this.element
    const addonFields = form.querySelectorAll('[data-mandatory="true"]')
    let isValid = true
    const missingFields = []

    addonFields.forEach(field => {
      const fieldType = field.type || field.tagName.toLowerCase()
      let isEmpty = false

      if (fieldType === 'checkbox') {
        // For checkboxes, check if it's checked
        isEmpty = !field.checked
      } else if (fieldType === 'textarea') {
        // For textareas, check if value is empty or just whitespace
        isEmpty = !field.value || field.value.trim() === ''
      } else {
        // For other fields (text, number, date), check if value is empty
        isEmpty = !field.value || field.value.trim() === ''
      }

      if (isEmpty) {
        isValid = false
        const fieldLabel = field.dataset.fieldLabel || 'Field'
        missingFields.push(fieldLabel)

        // Add error styling
        field.classList.add('border-red-500')
        field.classList.remove('border-gray-300')

        // Show error message if not already present
        let errorMsg = field.parentElement.querySelector('.addon-error-message')
        if (!errorMsg) {
          errorMsg = document.createElement('p')
          errorMsg.className = 'text-red-500 text-xs mt-1 addon-error-message'
          errorMsg.textContent = 'This field is required'
          field.parentElement.appendChild(errorMsg)
        }
      } else {
        // Remove error styling if field is filled
        field.classList.remove('border-red-500')
        field.classList.add('border-gray-300')

        // Remove error message if present
        const errorMsg = field.parentElement.querySelector('.addon-error-message')
        if (errorMsg) {
          errorMsg.remove()
        }
      }
    })

    if (!isValid) {
      event.preventDefault()
      event.stopPropagation()

      // Show alert with missing fields
      const fieldsList = missingFields.join(', ')
      alert(`Please fill in all required fields:\n\n${fieldsList}`)

      // Scroll to first missing field
      const firstEmptyField = form.querySelector('[data-mandatory="true"].border-red-500')
      if (firstEmptyField) {
        firstEmptyField.scrollIntoView({ behavior: 'smooth', block: 'center' })
        firstEmptyField.focus()
      }

      return false
    }

    return true
  }
}
